import { Component, inject } from '@angular/core';

import { ButtonComponent } from '@program-suite/ui';
import { ProgramGuidelinesStore } from '../data/program-guidelines.store';
import { toDateOnly } from '@program-suite/util-helpers';
import { ActivatedRoute } from '@angular/router';
import { ClassAccordionComponent } from "../class-accordion/class-accordion.component";

@Component({
  selector: 'lib-feature-program-guidelines-details',
  imports: [ButtonComponent, ClassAccordionComponent],
  templateUrl: './feature-program-guidelines-details.component.html',
  styleUrl: './feature-program-guidelines-details.component.scss',
})
export class ProgramGuidelinesDetailsComponent {
  programGuidelinesStore = inject(ProgramGuidelinesStore);
  program: string | null = null;
  isPastJuly2026 = new Date() >= new Date(2026, 6, 1);
  constructor(
    private route: ActivatedRoute,
    ) {
      this.program = this.route.snapshot.paramMap.get('id');
      var dateOnly = toDateOnly(new Date());
      this.programGuidelinesStore.getEligibilityStatement({program: this.program, state: 'CA', date: dateOnly});
  }


  get classStatements(): any[] {
    const result = this.programGuidelinesStore.eligibilityStatement?.()?.classStatements;
    if (Array.isArray(result)) {
      return result;
    }
    if (result && typeof result === 'object') {
      return Object.values(result);
    }
    return [];
  }

  get programStatementSections(): any[] {
    const result = this.programGuidelinesStore.eligibilityStatement?.()?.programStatementSections;
    if (Array.isArray(result)) {
      return result;
    }
    if (result && typeof result === 'object') {
      return Object.values(result);
    }
    return [];
  }
}
